import * as React from 'react';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import {
    Grid,
} from '@mui/material';

export default function GarmentCar({ data }) {
    const evaluateText=(item)=>{
        return item === '' ? 'Sin información':item
    }
    return (
        <Card>
            {/* <CardHeader
                sx={{}}
                title="Información de la Prenda"
            /> */}
            <CardContent>
                <Grid container>
                    <Grid xs={12} sm={6} md={6}>
                        <Grid container>
                            <Grid sx={{ color: 'text.secondary', mb: 0 }} xs={12} sm={12} md={12}><Typography sx={{ fontSize: 12 }}>Patente:</Typography></Grid>
                            <Grid sx={{ mb: 0 }} xs={12} sm={12} md={12}><Typography>{evaluateText(data.patent)}</Typography></Grid>
                        </Grid>
                        <Grid container>
                            <Grid sx={{ color: 'text.secondary', mb: 0 }} xs={12} sm={12} md={12}><Typography sx={{ fontSize: 12 }}>Tipo de vehiculo:</Typography></Grid>
                            <Grid sx={{ mb: 0 }} xs={12} sm={12} md={12}><Typography>{evaluateText(data.type)}</Typography></Grid>
                        </Grid>
                        <Grid container>
                            <Grid sx={{ color: 'text.secondary', mb: 0 }} xs={12} sm={12} md={12}><Typography sx={{ fontSize: 12 }}>Marca:</Typography></Grid>
                            <Grid sx={{ mb: 0 }} xs={12} sm={12} md={12}><Typography>{evaluateText(data.brand)}</Typography></Grid>
                        </Grid>
                        <Grid container>
                            <Grid sx={{ color: 'text.secondary', mb: 0 }} xs={12} sm={12} md={12}><Typography sx={{ fontSize: 12 }}>Modelo:</Typography></Grid>
                            <Grid sx={{ mb: 0 }} xs={12} sm={12} md={12}><Typography>{evaluateText(data.model)}</Typography></Grid>
                        </Grid>
                        <Grid container>
                            <Grid sx={{ color: 'text.secondary', mb: 0 }} xs={12} sm={12} md={12}><Typography sx={{ fontSize: 12 }}>Año:</Typography></Grid>
                            <Grid sx={{ mb: 0 }} xs={12} sm={12} md={12}><Typography>{evaluateText(data.year)}</Typography></Grid>
                        </Grid>
                    </Grid>
                    <Grid xs={12} sm={6} md={6}>
                        <Grid container>
                            <Grid sx={{ color: 'text.secondary', mb: 0 }} xs={12} sm={12} md={12}><Typography sx={{ fontSize: 12 }}>Color:</Typography></Grid>
                            <Grid sx={{ mb: 0 }} xs={12} sm={12} md={12}><Typography>{evaluateText(data.color)}</Typography></Grid>
                        </Grid>
                        <Grid container>
                            <Grid sx={{ color: 'text.secondary', mb: 0 }} xs={12} sm={12} md={12}><Typography sx={{ fontSize: 12 }}>Motor:</Typography></Grid>
                            <Grid sx={{ mb: 0 }} xs={12} sm={12} md={12}><Typography>{evaluateText(data.numberEngine)}</Typography></Grid>
                        </Grid>
                        <Grid container>
                            <Grid sx={{ color: 'text.secondary', mb: 0 }} xs={12} sm={12} md={12}><Typography sx={{ fontSize: 12 }}>Chasis:</Typography></Grid>
                            <Grid sx={{ mb: 0 }} xs={12} sm={12} md={12}><Typography>{evaluateText(data.numberChassis)}</Typography></Grid>
                        </Grid>
                        <Grid container>
                            <Grid sx={{ color: 'text.secondary', mb: 0 }} xs={12} sm={12} md={12}><Typography sx={{ fontSize: 12 }}>Vin:</Typography></Grid>
                            <Grid sx={{ mb: 0 }} xs={12} sm={12} md={12}><Typography>{evaluateText(data.numberVin)}</Typography></Grid>
                        </Grid>
                    </Grid>

                </Grid>

                {/* <Typography variant="body2" sx={{ color: 'text.secondary' }}>
          Lizards are a widespread group of squamate reptiles, with over 6,000
          species, ranging across all continents except Antarctica
        </Typography> */}
            </CardContent>
            {/* <CardActions>
        <Button size="small">Share</Button>
        <Button size="small">Learn More</Button>
      </CardActions> */}
        </Card>
    );
}